import React, { FC } from 'react';
import { Box, Text, Icon, IconSize, Button, ButtonAppearance } from '@bechtel/gds';
import { RodRequestHeaderStyled, RodRequestStatusStyled, RodRequestStatusTextStyled } from './styled';
import { useLingui } from '@lingui/react';
import { useDate } from '@bechtel/client-common';
import { Trans } from '@lingui/macro';
import { RodRequestStatusMessages } from '~/components';
import { RodRequestDetailsSideSheet } from './details';
import { RodRequest } from '@bechtel/types';

export interface RodRequestHeaderProps {
  rodRequestItem: RodRequest;
}

export const RodRequestHeader: FC<RodRequestHeaderProps> = ({ rodRequestItem }) => {
  const [detailsSideSheetVisible, setDetailsSideSheetVisible] = React.useState(false);
  const { i18n } = useLingui();
  const { formatISODate } = useDate();

  return (
    <>
      <RodRequestHeaderStyled data-testid="rod-requests-header">
        <Box justifyContent={{ sm: 'space-between' }} alignItems={{ sm: 'center' }} style={{ width: '100%' }}>
          <Box flexDirection={{ sm: 'column' }}>
            <Box flexDirection={{ sm: 'row' }} alignItems={{ sm: 'center' }}>
              <Text size="400" family="graphik" color="white" weight="600" data-testid="rod-request-name">
                {rodRequestItem?.requestNumber}
              </Text>
              <RodRequestStatusStyled status={rodRequestItem?.currentStatusI18n}>
                <RodRequestStatusTextStyled status={rodRequestItem?.currentStatusI18n} data-testid="rod-request-status">
                  {i18n._(RodRequestStatusMessages[rodRequestItem?.currentStatusI18n])}
                </RodRequestStatusTextStyled>
              </RodRequestStatusStyled>
            </Box>
            <Box py={{ sm: '100' }} mb={{ sm: '200' }} data-testid="rod-request-requestedDate">
              <Text size="300" family="graphik" color="white">
                <Trans>Request Date</Trans>: &nbsp;
              </Text>
              <Text weight="600" size="300" family="graphik" color="white">
                {formatISODate(rodRequestItem.pickUpTime, 'dd MMM')}
              </Text>
            </Box>
          </Box>
        </Box>
        <Box
          css={`
            ${({ theme }: any) => `gap: ${theme.spacings[450]};`}
          `}
        >
          <Button css={{ width: '138px' }} appearance={ButtonAppearance.PRIMARY}>
            <Box
              css={`
                ${({ theme }: any) => `gap: ${theme.spacings[400]};`}
              `}
            >
              <Icon icon="file-spreadsheet" size={IconSize.MEDIUM} fillColor="bechtel.white" />
              <Text size="300" family="graphik">
                <Trans>View Slip</Trans>
              </Text>
            </Box>
          </Button>
          <Button
            css={{ width: '80px' }}
            appearance={ButtonAppearance.SECONDARY}
            onClick={() => setDetailsSideSheetVisible(true)}
          >
            <Box
              css={`
                ${({ theme }: any) => `gap: ${theme.spacings[400]};`}
              `}
            >
              <Icon icon="list" size={IconSize.MEDIUM} fillColor="bechtel.blue.800" />
              <Text size="300" family="graphik">
                <Trans>Details</Trans>
              </Text>
            </Box>
          </Button>
        </Box>
      </RodRequestHeaderStyled>
      {detailsSideSheetVisible && (
        <RodRequestDetailsSideSheet
          rodRequestItem={rodRequestItem}
          detailsSideSheetVisible={detailsSideSheetVisible}
          setDetailsSideSheetVisible={setDetailsSideSheetVisible}
        ></RodRequestDetailsSideSheet>
      )}
    </>
  );
};
